<template>
    <div>
        <wap-header></wap-header>
        <div class="wap-box">
          <div class="select-header">
                <div :class="tabIndex==1?'active':''" @click="btn_tab(1)">新能源材料</div>
                <div :class="tabIndex==2?'active':''" @click="btn_tab(2)">腈类化合物及其衍生物</div>
                <div :class="tabIndex==3?'active':''" @click="btn_tab(3)">基础化学品</div>
          </div>
          <div class="right">
              <img :src="imgUrl" style="border-radius:10px;">
          </div>
          <div class="listBox">
            <div class="lis" v-for="item in list" :key="item.id" @click="to_detail(item.id)">
                <div class="imgs">
                    <img :src="require('@/assets/image/product/'+item.image)">
                </div>
                <div class="name">{{item.name}}</div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    import header1 from '@/assets/image/products/header1-1.png'
    import header2 from '@/assets/image/products/header1-2.png'
    import header3 from '@/assets/image/products/header1-3.png'

    export default {
        name: "productWap",
        components:{wapHeader,wapFooter},
        data(){
            return{
                tabIndex:1,
                imgUrl:'',
                list:[]
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.tabIndex = Number(this.$route.query.type);
                }
                this.getData()
            }
        },
        mounted() {
            if(this.$route.query.type){
                this.tabIndex = Number(this.$route.query.type);
            }
            this.getData()
        },
        methods:{
            to_detail(id){
                // this.$router.push('/productDetail?id='+id+"&tabIndex="+this.tabIndex);

                let pathName =  window.location.pathname;
                if(pathName ==` '/productDetail?id='+${id}&wapShow=true`)return;
                this.$router.push({
                    path:'/productDetail?id='+id,
                    query:{wapShow:true}
                });
            },
            getData(){
                const newEnergy =require('../../..//assets/JSONData/product/newEnergy.json');
                const nitrileCompound =require('../../../assets/JSONData/product/nitrileCompound.json');
                const basics =require('../../..//assets/JSONData/product/basics.json');
                switch (this.tabIndex) {
                    case 1:
                        this.list = newEnergy;
                        this.imgUrl = header1
                        break
                    case 2:
                        this.list = nitrileCompound;
                        this.imgUrl = header2
                        break
                    case 3:
                        this.list = basics;
                        this.imgUrl = header3
                        break
                }
            },
            btn_tab(index){
                const newEnergy =require('../../..//assets/JSONData/product/newEnergy.json');
                const nitrileCompound =require('../../..//assets/JSONData/product/nitrileCompound.json');
                const basics =require('../../..//assets/JSONData/product/basics.json');
                this.tabIndex= Number(index);
                switch (this.tabIndex) {
                    case 1:
                        this.list = newEnergy;
                        this.imgUrl = header1
                        break
                    case 2:
                        this.list = nitrileCompound;
                        this.imgUrl = header2
                        break
                    case 3:
                        this.list = basics;
                        this.imgUrl = header3
                        break
                }
            }
        }
    }
</script>

<style scoped>
    .select-header{
        width:355px;
        height:52px;
        margin:10px auto 0;
        display: flex;
        background: #007ED2;
        border-radius: 10px 10px 0 0;
    }
    .select-header div{
        width:34%;
        height: 45px;
        line-height: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px 10px 0 0;
        padding-top:7px;
    }
    .select-header div.active{
        background: rgba(0, 0, 0, 0.42);
    }
    .wap-box .right{
        width: 355px;
        height: 106px;
        border-radius: 10px;
        margin:10px auto 0;
    }
    .wap-box .right img{
        width: 100%;
    }

    .listBox{
        background: #ffffff;
        width:355px;
        margin:14px auto 20px;
    }
    .listBox .lis{
        width:168px;
        height:168px;
        float: left;
        margin-bottom:11px;
    }
    .listBox .lis .imgs{
        width: 168px;
        height: 131px;
        overflow: hidden;
        border-radius: 10px 10px  0 0;
        border: 2px solid #E6E8EB;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .listBox .lis .imgs img{
        height: 100%;
    }
    .listBox .lis .name{
        width: 162px;
        height: 41px;
        line-height: 40px;
        background: #0067AC;
        font-size: 13px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
        border-radius: 0px 0px 10px 10px;
        padding-left:6px;
    }
    .listBox .lis:nth-child(1){margin-right: 10px;}
    .listBox .lis:nth-child(3){margin-right: 11px;}

</style>
